import React from 'react';
import './GlassContainer.css';

interface GlassContainerProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Visual treatment. `default` is the original milky-white panel (Search pages).
   * `cardDetails` matches the Card Details page glass (darker gradient + 2px border),
   * centralized here so consumers reuse it rather than re-copying the CSS.
   */
  variant?: 'default' | 'cardDetails';
}

const GlassContainer: React.FC<GlassContainerProps> = ({ children, className, variant = 'default' }) => {
  const variantClass = variant === 'cardDetails' ? 'glass-container--card-details' : '';
  return <div className={`glass-container ${variantClass} ${className || ''}`}>{children}</div>;
};

export default GlassContainer;
